(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PublicHoliday', PublicHoliday);

    PublicHoliday.$inject = ['$resource', 'DateUtils'];

    function PublicHoliday ($resource, DateUtils) {
        var resourceUrl =  'api/public-holidays/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.holidayDate = DateUtils.convertLocalDateFromServer(data.holidayDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.holidayDate = DateUtils.convertLocalDateToServer(copy.holidayDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.holidayDate = DateUtils.convertLocalDateToServer(copy.holidayDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
